import Home from '@/pages/Home'
import Video from '@/pages/Video'

export const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },

  {
    path: '/video',
    name: 'Video',
    component: Video,
  },

  { path: '*' },

];

export const VueRouterObject = {
  routes,
  mode: 'history',
  saveScrollPosition: true,
};

export default VueRouter => new VueRouter(VueRouterObject);



// WEBPACK FOOTER //
// ./src/config/router.js